import React from 'react';
import { useSelector } from 'react-redux';
import { useMyOrganizations } from '../../utils/useMyOrganizations';
import { RoleBadge } from '../../utils/roleLabels';

const EnrollmentTopBar = ({ title }) => {
    const { user } = useSelector((state) => state.auth);
    const { label } = useMyOrganizations();

    return (
        <nav className="shadow-sm p-3 mb-3 mr-4 ml-4 rounded d-flex justify-content-between align-items-center">
            <h5 style={{ color: '#004aad', margin: 0 }}>{title || 'Enrollment'}</h5>
            <div className="d-flex align-items-center" style={{ gap: 10 }}>
                <small className="text-muted">{label}</small>
                <RoleBadge role={user?.role} organizationIds={user?.organizationIds} />
                <strong>{user?.name}</strong>
            </div>
        </nav>
    );
};

export default EnrollmentTopBar;
